const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

export function campaignProperties(): Record<string, string> {
  if (typeof window === "undefined") return {};
  const params = new URLSearchParams(window.location.search);
  const current: Record<string, string> = {};
  for (const key of keys) {
    const value = params.get(key);
    if (value && value.length <= 256) current[key] = value;
  }
  try {
    if (Object.keys(current).length) window.sessionStorage.setItem("socialcast_campaign", new URLSearchParams(current).toString());
    const stored = new URLSearchParams(window.sessionStorage.getItem("socialcast_campaign") || "");
    for (const key of keys) {
      const value = stored.get(key);
      if (value && value.length <= 256 && !current[key]) current[key] = value;
    }
  } catch {}
  return current;
}
